appBeneficiario.controller('desbloqueioDeCartaoModalController', ['$scope', '$uibModalInstance', 'cardNumber', 'tipoDesloqueio', function ($scope, $uibModalInstance, cardNumber, tipoDesloqueio) {
  $scope.cardNumber = cardNumber;
  $scope.tipoDesloqueio = tipoDesloqueio;

  $scope.close = function () {
    $uibModalInstance.dismiss();
  };

  $scope.checkCardAmount = function () {
    $uibModalInstance.close(tipoDesloqueio);
  };

  if (constants.SETTINGS.DEBUG) {
    $scope.exposeScope('desbloqueioDeCartaoModalController', $scope);
  }

}]);
